// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PostSubjectMarkFilesImportBody, BaseResponseVoid } from '../../types';

/**
 * 导入话题
 *
 * @export
 * @tags 话题标注
 * @link [POST] /subjectMarkFiles/import
 */
export function postSubjectMarkFilesImport(
    data: PostSubjectMarkFilesImportBody
): Promise<BaseResponseVoid>;
export function postSubjectMarkFilesImport(
    data: PostSubjectMarkFilesImportBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postSubjectMarkFilesImport(
    data: PostSubjectMarkFilesImportBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostSubjectMarkFilesImportBody, never, never>('/subjectMarkFiles/import', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postSubjectMarkFilesImport',
    });
}

export const meta = [{ tags: ['话题标注'], path: '/subjectMarkFiles/import', method: 'post' }];
